import { render } from "./Home.vue?vue&type=template&id=8e3f34de&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=8e3f34de&lang=scss"
import "./custom-home.scss?vue&type=style&index=1&id=8e3f34de&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e3f34de"]])

export default __exports__